import { DatePickerFormField, SelectFormField, TextFormField } from 'components/Forms/FormFields';
import { useFormContext } from 'contexts/formContext';
import { CurrentValuesSelected } from '../CurrentValuesSelected/CurrentValuesSelected';
import { FilterStyleBase } from '../MethodsForFilters/FilterStyleBase';
import { Grid, InputAdornment } from '@mui/material';
import CurrencyFormField, { ICurrencyFormFieldProps } from 'components/Forms/FormFields/CurrencyFormField/CurrencyFormField';
import { FieldValues } from 'react-hook-form';
import { ActionSubmitSearch } from 'components/Actions/ActionSubmitSearch';

type ParcelsBatchFiltersProps = {
    currentValues: any,
    removeFilterSelected: (index: number) => void;
    overrideOnClickFilter: (values: FieldValues) => void;
}

type ParcelsBatchAssignmentFilterFormProps = Pick<ParcelsBatchFiltersProps, 'overrideOnClickFilter'>;

function ParcelsBatchAssignmentFilterForm({ overrideOnClickFilter }: ParcelsBatchAssignmentFilterFormProps) {
    const { watch } = useFormContext();

    const onClickSubmit = () => overrideOnClickFilter?.(watch());

    const currencyDefaultProps = (name: string) => {
        return {
            name,
            fullWidth: true,
            variant: "outlined",
            required: true,
            showEndAdornment: true,
            endAdornmentType: 'button',
            overrideOnClickFilter: onClickSubmit,
        } as ICurrencyFormFieldProps;
    };

    return (
        <>
            <SelectFormField
                name='optionFilter'
                label='Filtrar por'
                variant='outlined'
                fullWidth
                options={[
                    { label: "Todos", value: 'searchString' },
                    { label: "Data de vencimento", value: 'initialDate' },
                    { label: "Valor da Parcela (Máximo)", value: 'maxPaymentValue' },
                    { label: "Valor da Parcela (Mínimo)", value: 'minPaymentValue' },
                    { label: "Valor da Cessão (Máximo)", value: 'maxAssignmentValue' },
                    { label: "Valor da Cessão (Mínimo)", value: 'minAssignmentValue' },
                    { label: "Número da operação", value: 'creditNoteNo' },
                ]}
            />
            {watch('optionFilter') === 'searchString' && (
                <TextFormField
                    name='searchString'
                    variant='outlined'
                    label='Filtrar por todos'
                    fullWidth
                    InputProps={{
                        endAdornment: (
                            <ActionSubmitSearch typeButton='button' onClick={onClickSubmit} />
                        )
                    }}
                />
            )}
            {watch('optionFilter') === 'creditNoteNo' && (
                <TextFormField
                    label="Filtrar por número da operação"
                    name="creditNoteNo"
                    variant="outlined"
                    fullWidth
                    type="number"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start" sx={{ marginRight: -5 }}>
                                <span
                                    style={{
                                        display: 'block',
                                        fontSize: '20px',
                                    }}
                                >
                                    #
                                </span>
                            </InputAdornment>
                        ),
                        endAdornment: (
                            <ActionSubmitSearch typeButton='button' onClick={onClickSubmit} />
                        )
                    }}
                />
            )}
            {watch('optionFilter') === 'maxPaymentValue' && (
                <CurrencyFormField
                    label="Filtrar por Valor da Parcela (Máximo)"
                    {...currencyDefaultProps('maxPaymentValue')}
                />
            )}
            {watch('optionFilter') === 'minPaymentValue' && (
                <CurrencyFormField
                    label="Filtrar por Valor da Parcela (Mínimo)"
                    {...currencyDefaultProps('minPaymentValue')}
                />
            )}
            {watch('optionFilter') === 'maxAssignmentValue' && (
                <CurrencyFormField
                    label="Filtrar por Valor da Cessão (Máximo)"
                    {...currencyDefaultProps('maxAssignmentValue')}

                />
            )}
            {watch('optionFilter') === 'minAssignmentValue' && (
                <CurrencyFormField
                    label="Filtrar por Valor da Cessão (Mínimo)"
                    {...currencyDefaultProps('minAssignmentValue')}
                />
            )}

            {watch('optionFilter') === 'initialDate' && (
                <Grid
                    sx={{
                        display: 'grid',
                        alignItems: 'center',
                        gridTemplateColumns: 'auto auto',
                        gridGap: 10,
                    }}
                >
                    <DatePickerFormField
                        label="Data de vencimento"
                        name="initialDate"
                        fullWidth
                        required
                    />
                    <DatePickerFormField
                        label="Filtrar por data final"
                        name="finalDate"
                        fullWidth
                        required
                        componentFilter={
                            <ActionSubmitSearch typeButton='button' onClick={onClickSubmit} />
                        }
                    />
                </Grid>
            )}
        </>
    )
}

export const ParcelsBatchAssignmentFilter = ({ currentValues, removeFilterSelected, overrideOnClickFilter }: ParcelsBatchFiltersProps) => {
    return (
        <FilterStyleBase
            formFilters={<ParcelsBatchAssignmentFilterForm overrideOnClickFilter={overrideOnClickFilter} />}
            currentValues={
                <CurrentValuesSelected
                    currentValues={currentValues}
                    removeFilterSelected={removeFilterSelected}
                />
            }
        />
    )
}
